import { g as ne } from "./@contentful-cca97bae.js";
import { l as ie } from "./htmlparser2-114782f1.js";
import { e as se } from "./escape-string-regexp-6e61e2c5.js";
import { i as le } from "./is-plain-object-c0b50e48.js";
import { p as oe } from "./parse-srcset-ecafb4d2.js";
import { p as ae } from "./postcss-68ef818a.js";
var ce = function(e) {
  return fe(e) && !de(e);
};
function fe(i) {
  return !!i && typeof i == "object";
}
function de(i) {
  var e = Object.prototype.toString.call(i);
  return e === "[object RegExp]" || e === "[object Date]" || pe(i);
}
var ue = typeof Symbol == "function" && Symbol.for, ge = ue ? Symbol.for("react.element") : 60103;
function pe(i) {
  return i.$$typeof === ge;
}
function me(i) {
  return Array.isArray(i) ? [] : {};
}
function k(i, e) {
  return e.clone !== !1 && e.isMergeableObject(i) ? R(me(i), i, e) : i;
}
function he(i, e, o) {
  return i.concat(e).map(function(s) {
    return k(s, o);
  });
}
function be(i, e) {
  if (!e.customMerge)
    return R;
  var o = e.customMerge(i);
  return typeof o == "function" ? o : R;
}
function we(i) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(i).filter(function(e) {
    return Object.propertyIsEnumerable.call(i, e);
  }) : [];
}
function q(i) {
  return Object.keys(i).concat(we(i));
}
function X(i, e) {
  try {
    return e in i;
  } catch {
    return !1;
  }
}
function ye(i, e) {
  return X(i, e) && !(Object.hasOwnProperty.call(i, e) && Object.propertyIsEnumerable.call(i, e));
}
function xe(i, e, o) {
  var s = {};
  return o.isMergeableObject(i) && q(i).forEach(function(a) {
    s[a] = k(i[a], o);
  }), q(e).forEach(function(a) {
    ye(i, a) || (X(i, a) && o.isMergeableObject(e[a]) ? s[a] = be(a, o)(i[a], e[a], o) : s[a] = k(e[a], o));
  }), s;
}
function R(i, e, o) {
  o = o || {}, o.arrayMerge = o.arrayMerge || he, o.isMergeableObject = o.isMergeableObject || ce, o.cloneUnlessOtherwiseSpecified = k;
  var s = Array.isArray(e), a = Array.isArray(i), T = s === a;
  return T ? s ? o.arrayMerge(i, e, o) : xe(i, e, o) : k(e, o);
}
R.all = function(e, o) {
  if (!Array.isArray(e))
    throw new Error("first argument should be an array");
  return e.reduce(function(s, a) {
    return R(s, a, o);
  }, {});
};
var Te = R, Ae = Te;
const Oe = ie, Z = se, { isPlainObject: Se } = le, Y = Ae, Me = oe, { parse: Ee } = ae, Re = [
  "img",
  "audio",
  "video",
  "picture",
  "svg",
  "object",
  "map",
  "iframe",
  "embed"
], ve = ["script", "style"];
function j(i, e) {
  i && Object.keys(i).forEach(function(o) {
    e(i[o], o);
  });
}
function x(i, e) {
  return {}.hasOwnProperty.call(i, e);
}
function K(i, e) {
  const o = [];
  return j(i, function(s) {
    e(s) && o.push(s);
  }), o;
}
function Ce(i) {
  for (const e in i)
    if (x(i, e))
      return !1;
  return !0;
}
function Pe(i) {
  return i.map(function(e) {
    if (!e.url)
      throw new Error("URL missing");
    return e.url + (e.w ? ` ${e.w}w` : "") + (e.h ? ` ${e.h}h` : "") + (e.d ? ` ${e.d}x` : "");
  }).join(", ");
}
var je = $;
const ke = /^[^\0\t\n\f\r /<=>]+$/;
function $(i, e, o) {
  if (i == null)
    return "";
  typeof i == "number" && (i = i.toString());
  let s = "", a = "";
  function T(t, n) {
    const r = this;
    this.tag = t, this.attribs = n || {}, this.tagPosition = s.length, this.text = "", this.mediaChildren = [], this.updateParentNodeText = function() {
      if (p.length) {
        const l = p[p.length - 1];
        l.text += r.text;
      }
    }, this.updateParentNodeMediaChildren = function() {
      p.length && Re.includes(this.tag) && p[p.length - 1].mediaChildren.push(this.tag);
    };
  }
  e = Object.assign({}, $.defaults, e), e.parser = Object.assign({}, $e, e.parser);
  const H = function(t) {
    return e.allowedTags === !1 || (e.allowedTags || []).indexOf(t) > -1;
  };
  ve.forEach(function(t) {
    H(t) && !e.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${t}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
  });
  const J = e.nonTextTags || [
    "script",
    "style",
    "textarea",
    "option"
  ];
  let g, S;
  e.allowedAttributes && (g = {}, S = {}, j(e.allowedAttributes, function(t, n) {
    g[n] = [];
    const r = [];
    t.forEach(function(l) {
      typeof l == "string" && l.indexOf("*") >= 0 ? r.push(Z(l).replace(/\\\*/g, ".*")) : g[n].push(l);
    }), r.length && (S[n] = new RegExp("^(" + r.join("|") + ")$"));
  }));
  const v = {}, N = {}, F = {};
  j(e.allowedClasses, function(t, n) {
    if (g && (x(g, n) || (g[n] = []), g[n].push("class")), v[n] = t, Array.isArray(t)) {
      const r = [];
      v[n] = [], F[n] = [], t.forEach(function(l) {
        typeof l == "string" && l.indexOf("*") >= 0 ? r.push(Z(l).replace(/\\\*/g, ".*")) : l instanceof RegExp ? F[n].push(l) : v[n].push(l);
      }), r.length && (N[n] = new RegExp("^(" + r.join("|") + ")$"));
    }
  });
  const z = {};
  let D;
  j(e.transformTags, function(t, n) {
    let r;
    typeof t == "function" ? r = t : typeof t == "string" && (r = $.simpleTransform(t)), n === "*" ? D = r : z[n] = r;
  });
  let h, p, M, E, A, C, I = !1;
  _();
  const B = new Oe.Parser({
    onopentag: function(t, n) {
      if (e.enforceHtmlBoundary && t === "html" && _(), A) {
        C++;
        return;
      }
      const r = new T(t, n);
      p.push(r);
      let l = !1;
      const b = !!r.text;
      let m;
      if (x(z, t) && (m = z[t](t, n), r.attribs = n = m.attribs, m.text !== void 0 && (r.innerText = m.text), t !== m.tagName && (r.name = t = m.tagName, E[h] = m.tagName)), D && (m = D(t, n), r.attribs = n = m.attribs, t !== m.tagName && (r.name = t = m.tagName, E[h] = m.tagName)), (!H(t) || e.disallowedTagsMode === "recursiveEscape" && !Ce(M) || e.nestingLimit != null && h >= e.nestingLimit) && (l = !0, M[h] = !0, e.disallowedTagsMode === "discard" && J.indexOf(t) !== -1 && (A = !0, C = 1), M[h] = !0), h++, l) {
        if (e.disallowedTagsMode === "discard")
          return;
        a = s, s = "";
      }
      s += "<" + t, t === "script" && (e.allowedScriptHostnames || e.allowedScriptDomains) && (r.innerText = ""), (!g || x(g, t) || g["*"]) && j(n, function(u, d) {
        if (!ke.test(d)) {
          delete r.attribs[d];
          return;
        }
        if (u === "" && !e.allowedEmptyAttributes.includes(d) && (e.nonBooleanAttributes.includes(d) || e.nonBooleanAttributes.includes("*"))) {
          delete r.attribs[d];
          return;
        }
        let U = !1;
        if (!g || x(g, t) && g[t].indexOf(d) !== -1 || g["*"] && g["*"].indexOf(d) !== -1 || x(S, t) && S[t].test(d) || S["*"] && S["*"].test(d))
          U = !0;
        else if (g && g[t]) {
          for (const c of g[t])
            if (Se(c) && c.name && c.name === d) {
              U = !0;
              let f = "";
              if (c.multiple === !0) {
                const O = u.split(" ");
                for (const y of O)
                  c.values.indexOf(y) !== -1 && (f === "" ? f = y : f += " " + y);
              } else
                c.values.indexOf(u) >= 0 && (f = u);
              u = f;
            }
        }
        if (U) {
          if (e.allowedSchemesAppliedToAttributes.indexOf(d) !== -1 && L(t, u)) {
            delete r.attribs[d];
            return;
          }
          if (t === "script" && d === "src") {
            let c = !0;
            try {
              const f = G(u);
              if (e.allowedScriptHostnames || e.allowedScriptDomains) {
                const O = (e.allowedScriptHostnames || []).find(function(w) {
                  return w === f.url.hostname;
                }), y = (e.allowedScriptDomains || []).find(function(w) {
                  return f.url.hostname === w || f.url.hostname.endsWith(`.${w}`);
                });
                c = O || y;
              }
            } catch {
              c = !1;
            }
            if (!c) {
              delete r.attribs[d];
              return;
            }
          }
          if (t === "iframe" && d === "src") {
            let c = !0;
            try {
              const f = G(u);
              if (f.isRelativeUrl)
                c = x(e, "allowIframeRelativeUrls") ? e.allowIframeRelativeUrls : !e.allowedIframeHostnames && !e.allowedIframeDomains;
              else if (e.allowedIframeHostnames || e.allowedIframeDomains) {
                const O = (e.allowedIframeHostnames || []).find(function(w) {
                  return w === f.url.hostname;
                }), y = (e.allowedIframeDomains || []).find(function(w) {
                  return f.url.hostname === w || f.url.hostname.endsWith(`.${w}`);
                });
                c = O || y;
              }
            } catch {
              c = !1;
            }
            if (!c) {
              delete r.attribs[d];
              return;
            }
          }
          if (d === "srcset")
            try {
              let c = Me(u);
              if (c.forEach(function(f) {
                L("srcset", f.url) && (f.evil = !0);
              }), c = K(c, function(f) {
                return !f.evil;
              }), c.length)
                u = Pe(K(c, function(f) {
                  return !f.evil;
                })), r.attribs[d] = u;
              else {
                delete r.attribs[d];
                return;
              }
            } catch {
              delete r.attribs[d];
              return;
            }
          if (d === "class") {
            const c = v[t], f = v["*"], O = N[t], y = F[t], w = N["*"], W = [
              O,
              w
            ].concat(y).filter(function(re) {
              return re;
            });
            if (c && f ? u = V(u, Y(c, f), W) : u = V(u, c || f, W), !u.length) {
              delete r.attribs[d];
              return;
            }
          }
          if (d === "style") {
            if (e.parseStyleAttributes)
              try {
                const c = Ee(t + " {" + u + "}", { map: !1 }), f = Q(c, e.allowedStyles);
                if (u = ee(f), u.length === 0) {
                  delete r.attribs[d];
                  return;
                }
              } catch {
                typeof window < "u" && console.warn('Failed to parse "' + t + " {" + u + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete r.attribs[d];
                return;
              }
            else if (e.allowedStyles)
              throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
          }
          s += " " + d, u && u.length ? s += '="' + P(u, !0) + '"' : e.allowedEmptyAttributes.includes(d) && (s += '=""');
        } else
          delete r.attribs[d];
      }), e.selfClosing.indexOf(t) !== -1 ? s += " />" : (s += ">", r.innerText && !b && !e.textFilter && (s += P(r.innerText), I = !0)), l && (s = a + P(s), a = "");
    },
    ontext: function(t) {
      if (A)
        return;
      const n = p[p.length - 1];
      let r;
      if (n && (r = n.tag, t = n.innerText !== void 0 ? n.innerText : t), e.disallowedTagsMode === "discard" && (r === "script" || r === "style"))
        s += t;
      else {
        const l = P(t, !1);
        e.textFilter && !I ? s += e.textFilter(l, r) : I || (s += l);
      }
      if (p.length) {
        const l = p[p.length - 1];
        l.text += t;
      }
    },
    onclosetag: function(t, n) {
      if (A)
        if (C--, !C)
          A = !1;
        else
          return;
      const r = p.pop();
      if (!r)
        return;
      if (r.tag !== t) {
        p.push(r);
        return;
      }
      A = e.enforceHtmlBoundary ? t === "html" : !1, h--;
      const l = M[h];
      if (l) {
        if (delete M[h], e.disallowedTagsMode === "discard") {
          r.updateParentNodeText();
          return;
        }
        a = s, s = "";
      }
      if (E[h] && (t = E[h], delete E[h]), e.exclusiveFilter && e.exclusiveFilter(r)) {
        s = s.substr(0, r.tagPosition);
        return;
      }
      if (r.updateParentNodeMediaChildren(), r.updateParentNodeText(), // Already output />
      e.selfClosing.indexOf(t) !== -1 || // Escaped tag, closing tag is implied
      n && !H(t) && ["escape", "recursiveEscape"].indexOf(e.disallowedTagsMode) >= 0) {
        l && (s = a, a = "");
        return;
      }
      s += "</" + t + ">", l && (s = a + P(s), a = ""), I = !1;
    }
  }, e.parser);
  return B.write(i), B.end(), s;
  function _() {
    s = "", h = 0, p = [], M = {}, E = {}, A = !1, C = 0;
  }
  function P(t, n) {
    return typeof t != "string" && (t = t + ""), e.parser.decodeEntities && (t = t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), n && (t = t.replace(/"/g, "&quot;"))), t = t.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), n && (t = t.replace(/"/g, "&quot;")), t;
  }
  function L(t, n) {
    for (n = n.replace(/[\x00-\x20]+/g, ""); ; ) {
      const b = n.indexOf("<!--");
      if (b === -1)
        break;
      const m = n.indexOf("-->", b + 4);
      if (m === -1)
        break;
      n = n.substring(0, b) + n.substring(m + 3);
    }
    const r = n.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!r)
      return n.match(/^[/\\]{2}/) ? !e.allowProtocolRelative : !1;
    const l = r[1].toLowerCase();
    return x(e.allowedSchemesByTag, t) ? e.allowedSchemesByTag[t].indexOf(l) === -1 : !e.allowedSchemes || e.allowedSchemes.indexOf(l) === -1;
  }
  function G(t) {
    if (t = t.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), t.startsWith("relative:"))
      throw new Error("relative: exploit attempt");
    let n = "relative://relative-site";
    for (let b = 0; b < 100; b++)
      n += `/${b}`;
    const r = new URL(t, n);
    return {
      isRelativeUrl: r && r.hostname === "relative-site" && r.protocol === "relative:",
      url: r
    };
  }
  function Q(t, n) {
    if (!n)
      return t;
    const r = t.nodes[0];
    let l;
    return n[r.selector] && n["*"] ? l = Y(
      n[r.selector],
      n["*"]
    ) : l = n[r.selector] || n["*"], l && (t.nodes[0].nodes = r.nodes.reduce(te(l), [])), t;
  }
  function ee(t) {
    return t.nodes[0].nodes.reduce(function(n, r) {
      return n.push(
        `${r.prop}:${r.value}${r.important ? " !important" : ""}`
      ), n;
    }, []).join(";");
  }
  function te(t) {
    return function(n, r) {
      return x(t, r.prop) && t[r.prop].some(function(b) {
        return b.test(r.value);
      }) && n.push(r), n;
    };
  }
  function V(t, n, r) {
    return n ? (t = t.split(/\s+/), t.filter(function(l) {
      return n.indexOf(l) !== -1 || r.some(function(b) {
        return b.test(l);
      });
    }).join(" ")) : t;
  }
}
const $e = {
  decodeEntities: !0
};
$.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hgroup",
    "main",
    "nav",
    "section",
    // Text content
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "main",
    "ol",
    "p",
    "pre",
    "ul",
    // Inline text semantics
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    // Table content
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
  ],
  // Tags that cannot be boolean
  nonBooleanAttributes: [
    "abbr",
    "accept",
    "accept-charset",
    "accesskey",
    "action",
    "allow",
    "alt",
    "as",
    "autocapitalize",
    "autocomplete",
    "blocking",
    "charset",
    "cite",
    "class",
    "color",
    "cols",
    "colspan",
    "content",
    "contenteditable",
    "coords",
    "crossorigin",
    "data",
    "datetime",
    "decoding",
    "dir",
    "dirname",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "fetchpriority",
    "for",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formtarget",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "http-equiv",
    "id",
    "imagesizes",
    "imagesrcset",
    "inputmode",
    "integrity",
    "is",
    "itemid",
    "itemprop",
    "itemref",
    "itemtype",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "name",
    "nonce",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "referrerpolicy",
    "rel",
    "rows",
    "rowspan",
    "sandbox",
    "scope",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "spellcheck",
    "src",
    "srcdoc",
    "srclang",
    "srcset",
    "start",
    "step",
    "style",
    "tabindex",
    "target",
    "title",
    "translate",
    "type",
    "usemap",
    "value",
    "width",
    "wrap",
    // Event handlers
    "onauxclick",
    "onafterprint",
    "onbeforematch",
    "onbeforeprint",
    "onbeforeunload",
    "onbeforetoggle",
    "onblur",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "onchange",
    "onclick",
    "onclose",
    "oncontextlost",
    "oncontextmenu",
    "oncontextrestored",
    "oncopy",
    "oncuechange",
    "oncut",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onerror",
    "onfocus",
    "onformdata",
    "onhashchange",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onlanguagechange",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmessage",
    "onmessageerror",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onoffline",
    "ononline",
    "onpagehide",
    "onpageshow",
    "onpaste",
    "onpause",
    "onplay",
    "onplaying",
    "onpopstate",
    "onprogress",
    "onratechange",
    "onreset",
    "onresize",
    "onrejectionhandled",
    "onscroll",
    "onscrollend",
    "onsecuritypolicyviolation",
    "onseeked",
    "onseeking",
    "onselect",
    "onslotchange",
    "onstalled",
    "onstorage",
    "onsubmit",
    "onsuspend",
    "ontimeupdate",
    "ontoggle",
    "onunhandledrejection",
    "onunload",
    "onvolumechange",
    "onwaiting",
    "onwheel"
  ],
  disallowedTagsMode: "discard",
  allowedAttributes: {
    a: ["href", "name", "target"],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
  },
  allowedEmptyAttributes: [
    "alt"
  ],
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
  // URL schemes we permit
  allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
  allowProtocolRelative: !0,
  enforceHtmlBoundary: !1,
  parseStyleAttributes: !0
};
$.simpleTransform = function(i, e, o) {
  return o = o === void 0 ? !0 : o, e = e || {}, function(s, a) {
    let T;
    if (o)
      for (T in e)
        a[T] = e[T];
    else
      a = e;
    return {
      tagName: i,
      attribs: a
    };
  };
};
const Ue = /* @__PURE__ */ ne(je);
export {
  Ue as s
};
